// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import Container from '../../../common/container/Container'
import RestrictedRoute from '../../auth/RestrictedRoute'
import Header from '../../header/Header'
import { i18n } from '../../index'
import StationActivityDescriptionPage from '../activityDescription/StationActivityDescriptionPage'
import CampaignsPage from '../campaigns/CampaignsPage'
import StationChecklistPage from '../checklist/StationChecklistPage'
import StationFeelingsMeterQuestionsPage from '../feelingsMeterQuestions/FeelingsMeterQuestionsPage'
import StationIncentiveProductPage from '../incentiveProduct/StationIncentiveProductPage'
import StationRemindersPage from '../reminders/RemindersPage'
import ScoreCardThresholdsPage from '../scoreCardThresholds/ScoreCardThresholdsPage'
import StationShiftResponsibilityPage from '../shiftResponsibility/StationShiftResponsibilityPage'
import StationThumbableServicePage from '../thumbableService/StationThumbableServicePage'
import StationToiletCheckQuestionPage from '../toiletCheckQuestion/StationToiletCheckQuestionPage'
import StationBuffetPage from './StationBuffetPage'
import StationEmployeePage from './StationEmployeePage'
import StationGeneralPage from './StationGeneralPage'
import StationListPage from './StationListPage'
import StationNightTaskPage from './StationNightTaskPage'
import StationProfitCenterPage from './StationProfitCenterPage'
import css from './stationRoot.css'
import StationSettingsPage from './stationSettings/StationSettingsPage'
import StationWastageBoundaryPage from './wastageBoundaries/WastageBoundaryPage'
type StationRootProps = {
  history: any
  location: any
  match: any
}

class StationRoot extends React.PureComponent<StationRootProps> {
  getTabs = () => {
    return [
      {
        label: i18n.t('admin.stations.tab.general'),
        value: 'perustiedot',
      },
      {
        label: i18n.t('admin.stations.tab.employees'),
        value: 'tyontekijat',
      },
      {
        label: i18n.t('admin.stations.tab.profitCenters'),
        value: 'kustannuspaikat',
      },
      {
        label: i18n.t('admin.stations.tab.buffet'),
        value: 'noutopoyta',
      },
      {
        label: i18n.t('admin.stations.tab.nightTasks'),
        value: 'yovuoron-tehtavat',
      },
      {
        label: i18n.t('admin.stations.tab.checklists'),
        value: 'tarkastuslistat',
      },
      {
        label: i18n.t('admin.stations.tab.wastageBoundaries'),
        value: 'havikinrajaarvot',
      },
      {
        label: i18n.t('admin.stations.tab.scoreCardThresholds'),
        value: 'tuloskortinrajaarvot',
      },
      {
        label: i18n.t('admin.stations.tab.toiletCheckQuestions'),
        value: 'wc-tarkastuskysymykset',
      },
      {
        label: i18n.t('admin.stations.tab.feelingsMeterQuestions'),
        value: 'fiilismittari-kysymykset',
      },
      {
        label: i18n.t('admin.stations.tab.reminders'),
        value: 'muistutukset',
      },
      {
        label: i18n.t('admin.stations.tab.thumbableServices'),
        value: 'peukutettavat-palvelut',
      },
      {
        label: i18n.t('admin.stations.tab.incentiveSales'),
        value: 'aloitteellisen-myynnin-tuotteet',
      },
      {
        label: i18n.t('admin.stations.tab.shiftResponsibilities'),
        value: 'vastuut',
      },
      {
        label: i18n.t('admin.stations.tab.activityDescriptions'),
        value: 'aktiviteettien-kuvaukset',
      },
      {
        label: i18n.t('admin.stations.tab.settings'),
        value: 'asetukset',
      },
      { label: i18n.t('admin.stations.tab.campaigns'), value: 'kampanjat' },
    ]
  }
  getActiveTab = () => {
    const parts = this.props.location.pathname.split('/')
    return parts[parts.length - 2] || 'perustiedot'
  }
  isIndex = () => {
    const parts = this.props.location.pathname.split('/')
    return parts.length === 3
  }
  onTabClick = (tab) => {
    const parts = this.props.location.pathname.split('/')
    this.props.history.push([this.getBasePath(), tab.value, parts[4]].join('/'))
  }
  getBasePath = () => this.props.location.pathname.split('/').slice(0, 3).join('/')

  render() {
    const { match } = this.props
    return (
      <div className={css.component}>
        <Header
          title={i18n.t('admin.header')}
          tabs={!this.isIndex() ? this.getTabs() : []}
          tabActive={this.getActiveTab()}
          onTabClick={this.onTabClick}
        />
        <Container>
          <Typography variant='h6'>{i18n.t('admin.header')}</Typography>
          <Switch>
            <Route path={`${match.path}/perustiedot/:stationId`} component={StationGeneralPage} />
            <Route path={`${match.path}/tyontekijat/:stationId`} component={StationEmployeePage} />
            <Route path={`${match.path}/kustannuspaikat/:stationId`} component={StationProfitCenterPage} />
            <Route path={`${match.path}/noutopoyta/:stationId`} component={StationBuffetPage} />
            <Route path={`${match.path}/yovuoron-tehtavat/:stationId`} component={StationNightTaskPage} />
            <Route path={`${match.path}/tarkastuslistat/:stationId`} component={StationChecklistPage} />
            <Route path={`${match.path}/havikinrajaarvot/:stationId`} component={StationWastageBoundaryPage} />
            <Route path={`${match.path}/tuloskortinrajaarvot/:stationId`} component={ScoreCardThresholdsPage} />
            <Route
              path={`${match.path}/wc-tarkastuskysymykset/:stationId`}
              component={StationToiletCheckQuestionPage}
            />
            <Route path={`${match.path}/muistutukset/:stationId`} component={StationRemindersPage} />
            <Route
              path={`${match.path}/fiilismittari-kysymykset/:stationId`}
              component={StationFeelingsMeterQuestionsPage}
            />
            <Route path={`${match.path}/peukutettavat-palvelut/:stationId`} component={StationThumbableServicePage} />
            <Route
              path={`${match.path}/aloitteellisen-myynnin-tuotteet/:stationId`}
              component={StationIncentiveProductPage}
            />
            <Route path={`${match.path}/vastuut/:stationId`} component={StationShiftResponsibilityPage} />
            <Route
              path={`${match.path}/aktiviteettien-kuvaukset/:stationId`}
              component={StationActivityDescriptionPage}
            />
            <Route path={`${match.path}/asetukset/:stationId`} component={StationSettingsPage} />
            <Route path={`${match.path}/kampanjat/:stationId`} component={CampaignsPage} />
            <RestrictedRoute
              exact
              requiredPermission='manage_stations'
              path={`${match.path}/`}
              component={StationListPage}
            />
          </Switch>
        </Container>
      </div>
    )
  }
}

export default withRouter(StationRoot)
